import React from 'react';
import {withStore} from "../hocs";
import {observer} from "mobx-react";
import QuizModalWindow from "../components/modalWindow/QuizModalWindow";
import ConfirmConsentModalWindow from "../components/modalWindow/ConfirmConsentModalWindow";

// @ts-ignore
@withStore
@observer
export default class DopInfoPage extends React.Component{
    componentDidMount() {

    }

    render() {
// @ts-ignore
        const {store} = this.props;
        const {isAuth} = store?.mainStore

        let location = window.location.pathname

        return (
            <>{isAuth ? <>
                <a href="/dopInfo" style={location === "/dopInfo" ? {display: "none"} : {color: 'red',
                    margin: 'auto',
                    display: 'table',
                    textDecoration: "underline",
                    padding: 10,
                    textAlign: "center",
                    marginBottom: -10
                }} >
                    Внимание! Не упустите шанс получить дополнительную скидку по срокам оплаты.
                    Подробнее по ссылке..
                </a>

                {/*<QuizModalWindow/>*/}
                <ConfirmConsentModalWindow/>

            </>  : null}
            </>
        )
    }
}

